import { type ReactNode, createContext, useContext, useRef } from 'react'
import { type StoreApi, useStore as useZustandStore } from 'zustand'

import { AppStore, createAppStore } from './appStore'
import { AppStoreState } from './defaultState'

export const AppStoreContext = createContext<StoreApi<AppStore> | null>(null)

export interface StoreProviderProps {
  ssrData: Partial<AppStoreState>
  children: ReactNode
}

export const AppStoreProvider = ({ ssrData, children }: StoreProviderProps) => {
  const storeRef = useRef<StoreApi<AppStore>>()
  if (!storeRef.current) storeRef.current = createAppStore(ssrData)

  return (
    <AppStoreContext.Provider value={storeRef.current}>
      {children}
    </AppStoreContext.Provider>
  )
}

export const useStore = <T,>(selector: (store: AppStore) => T): T => {
  const appStoreContext = useContext(AppStoreContext)

  if (!appStoreContext) {
    throw new Error('useAppStore must be use within StoreProvider')
  }

  return useZustandStore(appStoreContext, selector)
}

export const useAppStore = () => useStore((store) => store)
